// Debug mode's panel (D-45, D-46): the log exactly as it would be saved, to
// read before handing it on, and the buttons to save or clear it.
import { useState } from 'react';
import { clearLog, logEvents, logFile, LOG_MAX } from '../debuglog.ts';

export function DebugPanel(props: { onClose: () => void; onDebugOff: () => void }) {
  const [, setShown] = useState(0);
  const refresh = () => setShown((n) => n + 1);
  const events = logEvents();
  const save = () => {
    const a = document.createElement('a');
    a.href = URL.createObjectURL(logFile());
    a.download = `flexpdf-log-${new Date().toISOString().slice(0, 19).replace(/[T:]/g, '-')}.json`;
    a.click();
    setTimeout(() => URL.revokeObjectURL(a.href), 1000);
  };
  return (
    <div data-testid="debug-panel" className="panel modal debug-panel" role="dialog" aria-modal="true" aria-label="Debug mode">
      <h2>Debug mode</h2>
      <p className="small">
        The last {LOG_MAX} things the app did in this tab, kept in this tab's memory only. The log holds how the PDF is built (versions, kinds of fonts and
        images, counts), never its name, text or pictures. Read it below before passing it on.
      </p>
      <pre data-testid="debug-log" className="debug-log">
        {events.length ? events.map((e) => JSON.stringify(e)).join('\n') : 'Nothing logged yet.'}
      </pre>
      <div className="actions">
        <button data-testid="debug-save" onClick={save}>
          Save log
        </button>
        <button data-testid="debug-refresh" onClick={refresh}>
          Refresh
        </button>
        <button
          data-testid="debug-clear"
          onClick={() => {
            clearLog();
            refresh();
          }}
        >
          Clear
        </button>
        <button data-testid="debug-close" onClick={props.onClose}>
          Close
        </button>
        <span className="spacer" />
        <button data-testid="debug-off" onClick={props.onDebugOff}>
          Turn debug mode off
        </button>
      </div>
    </div>
  );
}
